module.exports = __webpack_public_path__ + "static/website-665dae66cea810ace6fcb1068d0ff5d5.jpg";